import React from "react";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { Container, Col, Row, Breadcrumb, Card } from "react-bootstrap";
import banner from "../assets/images/gst-reform-inner.png";

import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

const settings = {
  autoplay: true,
  autoplaySpeed: 2000,
  dots: false,
  arrow: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  mode: "center",
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      },
    },
  ],
};
const floorSlide = {
  dots: true,
  arrow: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  mode: "center",
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      },
    },
  ],
};
const GSTReform = () => {
  const { t } = useTranslation();
  return (
    <div className="inncentre-page">
      <Helmet>
        <title>Nuvoco - GST Reform</title>
        <meta name="keywords" description="" />
        <meta name="description" content="" />
        <link rel="canonical" href="" />
      </Helmet>

      <div className="banner text-center position-relative">
        <img className="desktopbannerinner w-100" src={banner} alt="" />
        <img className="mobilebannerinner w-100" src={banner} alt="" />

        <div className="breadouter">
          <div className="container">
            <Breadcrumb className="mb-0 py-2">
              <Breadcrumb.Item href="#">{t("breadcrumb.home")}</Breadcrumb.Item>
              {/* <Breadcrumb.Item href="#">{t("gstreform.title")}</Breadcrumb.Item> */}
              <Breadcrumb.Item
                active
                href="https://getbootstrap.com/docs/4.0/components/breadcrumb/"
              >
                {t("gst reform")}
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>
      <Container className="">
        <section>
          <Row className="d-flex ">
            <Col md={12} className="mb-4">
              <p>
                <strong>Rates for Trade Segment </strong>
              </p>
              <div className="table-responsive">
                <table
                  border="0"
                  className="table table-bordered"
                  cellspacing="0"
                  cellpadding="0"
                >
                  <thead>
                    <tr>
                      <td width="102">
                        <strong>Brand</strong>
                      </td>
                      <td width="143">Product</td>
                      <td width="189">Regions</td>
                      <td width="96">
                        Current MRP <br /> (50 Kg Bag)
                      </td>
                      <td width="105">
                        Revised MRP <br /> (50 Kg Bag)
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td rowspan="2">
                        <strong>Concreto</strong>
                      </td>
                      <td>Concreto</td>
                      <td>Across Regions*</td>
                      <td>₹ 550</td>
                      <td>₹ 500</td>
                    </tr>
                    <tr>
                      <td>Concreto UNO</td>
                      <td>Across Regions*</td>
                      <td>₹ 600</td>
                      <td>₹ 550</td>
                    </tr>
                    <tr>
                      <td rowspan="5">
                        <strong>Duraguard</strong>
                      </td>
                      <td>Duraguard Microfibre</td>
                      <td>Across Regions*</td>
                      <td>₹ 550</td>
                      <td>₹ 500</td>
                    </tr>
                    <tr>
                      <td>Duraguard Xtra</td>
                      <td>Across Regions*</td>
                      <td>₹ 530</td>
                      <td>₹ 480</td>
                    </tr>
                    <tr>
                      <td>Duraguard Adstar PPC</td>
                      <td>Across Regions*</td>
                      <td>₹ 500</td>
                      <td>₹ 460</td>
                    </tr>
                    <tr>
                      <td>Duraguard Adstar PCC</td>
                      <td>Bihar</td>
                      <td>₹ 530</td>
                      <td>₹ 480</td>
                    </tr>
                    <tr>
                      <td>Duraguard PPC</td>
                      <td>Across Regions*</td>
                      <td>₹ 500</td>
                      <td>₹ 460</td>
                    </tr>
                    <tr>
                      <td rowspan="4">
                        <strong>Double Bull</strong>
                      </td>
                      <td>Double Bull Master</td>
                      <td>Haryana/Delhi/Western UP</td>
                      <td>₹ 600</td>
                      <td>₹ 550</td>
                    </tr>
                    <tr>
                      <td>Double Bull Master</td>
                      <td>Across Regions*</td>
                      <td>₹ 530</td>
                      <td>₹ 480</td>
                    </tr>
                    <tr>
                      <td>Double Bull PPC</td>
                      <td>Haryana/Delhi/Western UP</td>
                      <td>₹ 550</td>
                      <td>₹ 500</td>
                    </tr>
                    <tr>
                      <td>Double Bull PPC</td>
                      <td>Across Regions*</td>
                      <td>₹ 500</td>
                      <td>₹ 460</td>
                    </tr>
                    <tr>
                      <td rowspan="2">
                        <strong>Nirmax</strong>
                      </td>
                      <td>Nirmax PPC</td>
                      <td>Rajasthan</td>
                      <td>₹ 480</td>
                      <td>₹ 440</td>
                    </tr>
                    <tr>
                      <td>Nirmax OPC 43 &amp; 53</td>
                      <td>Rajasthan</td>
                      <td>₹ 510</td>
                      <td>₹ 470</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Premium Slag</strong>
                      </td>
                      <td>PSC</td>
                      <td>Across Regions*</td>
                      <td>₹ 500</td>
                      <td>₹ 460</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>PCC</strong>
                      </td>
                      <td>PCC</td>
                      <td>Across Regions*</td>
                      <td>₹ 500</td>
                      <td>₹ 460</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>OPC 43 &amp; 53</strong>
                      </td>
                      <td>OPC 43 &amp; 53</td>
                      <td>Across Regions*</td>
                      <td>₹ 530</td>
                      <td>₹ 480</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <p>
                <strong>*Exclusions </strong>{" "}
              </p>

              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th width="102">Brand</th>
                      <th width="143">Product</th>
                      <th width="189">Regions</th>
                      <th width="96">
                        Current MRP <br /> (50 Kg Bag)
                      </th>
                      <th width="105">
                        Revised MRP <br /> (50 Kg Bag)
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td rowspan="8">
                        <strong>Duraguard</strong>
                      </td>
                      <td>Duraguard</td>
                      <td>North East</td>
                      <td>₹ 630</td>
                      <td>₹ 580</td>
                    </tr>
                    <tr>
                      <td>Duraguard Microfibre</td>
                      <td>North East</td>
                      <td>₹ 550</td>
                      <td>₹ 500</td>
                    </tr>
                    <tr>
                      <td>Duraguard Microfibre</td>
                      <td>Andhra Pradesh/Telangana</td>
                      <td>₹ 550</td>
                      <td>₹ 500</td>
                    </tr>
                    <tr>
                      <td>Duraguard Xtra</td>
                      <td>North East</td>
                      <td>₹ 630</td>
                      <td>₹ 580</td>
                    </tr>
                    <tr>
                      <td>Duraguard Xtra</td>
                      <td>Punjab/Eastern Uttar Pradesh</td>
                      <td>₹ 530</td>
                      <td>₹ 480</td>
                    </tr>
                    <tr>
                      <td>Duraguard Adstar</td>
                      <td>Punjab/Eastern Uttar Pradesh</td>
                      <td>₹ 500</td>
                      <td>₹ 460</td>
                    </tr>
                    <tr>
                      <td>Duraguard PPC</td>
                      <td>Punjab/Eastern Uttar Pradesh</td>
                      <td>₹ 500</td>
                      <td>₹ 460</td>
                    </tr>
                    <tr>
                      <td>Duraguard PPC</td>
                      <td>Andhra Pradesh/Telangana</td>
                      <td>₹ 500</td>
                      <td>₹ 460</td>
                    </tr>
                    <tr>
                      <td rowspan="4">
                        <strong>Double Bull</strong>
                      </td>
                      <td>Double Bull Master</td>
                      <td>North East</td>
                      <td>₹ 530</td>
                      <td>₹ 480</td>
                    </tr>
                    <tr>
                      <td>Double Bull PPC</td>
                      <td>North East</td>
                      <td>₹ 500</td>
                      <td>₹ 460</td>
                    </tr>
                    <tr>
                      <td>Double Bull PPC</td>
                      <td>Punjab/Eastern Uttar Pradesh</td>
                      <td>₹ 500</td>
                      <td>₹ 460</td>
                    </tr>
                    <tr>
                      <td>Double Bull PPC</td>
                      <td>Eastern Madhya Pradesh</td>
                      <td>₹ 355</td>
                      <td>₹ 320</td>
                    </tr>
                    <tr>
                      <td rowspan="2">
                        <strong>OPC</strong>
                      </td>
                      <td>OPC 43</td>
                      <td>Punjab/Eastern Uttar Pradesh</td>
                      <td>₹ 530</td>
                      <td>₹ 480</td>
                    </tr>
                    <tr>
                      <td>OPC 53</td>
                      <td>Punjab/Eastern Uttar Pradesh</td>
                      <td>₹ 530</td>
                      <td>₹ 480</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p>
                <strong>*Note:</strong>{" "}
                <em>Exclusive rates for Consignment Agents</em>
              </p>
            </Col>
          </Row>
        </section>
      </Container>
    </div>
  );
};

export default GSTReform;
